
export function refineCurriculumList( rawCurriculums ) {
    if ( !rawCurriculums ) { return undefined; }

    // Convert the list of raw curriculums into their "refined" forms.
    const refinedCurriculumList = rawCurriculums?.edges?.map( ( curriculumNode ) => {
        return {
            ...curriculumNode?.node,
            lxp: {
                relatedResourceBrandIds: curriculumNode.node.brandIds,
                relatedResourceLocaleIds: curriculumNode.node.localeIds,
                relatedResourceCompanyRelationshipIds: curriculumNode.node.companyRelationshipIds,
                relatedResourceProductIds: curriculumNode.node.productIds,
                tags: curriculumNode.node.tags,
            }
        };
    } );

    return refinedCurriculumList;
}
